<template>
    <button
      class="bg-gray-800 hover:bg-gray-700 text-gray-300 font-medium px-4 py-2 rounded-xl transition duration-200 border border-gray-700 focus:outline-none focus:ring focus:ring-gray-500"
    >
      <slot></slot>
    </button>
</template>
<script setup>

</script>

<script>
  export default {
    name: 'SecondaryButton'
  }
</script>
  